module.exports = __webpack_public_path__ + "bff851e4a55128cfcb334e0b32abeb48.js";